// src/pages/Stable.tsx
import React, { useState, useEffect } from 'react'
import api from '../api/axios'
import './Stable.css'
import buttonImg   from '../assets/stable/button.png'
import donkeyImg   from '../assets/stable/donkey.png'
import horseImg    from '../assets/stable/horse.png'
import unicornImg  from '../assets/stable/unicorn.png'

interface MountOption {
  name: string
  price_silver: number
  price_gold: number
  benefit: string
  cooldown_bonus: number
}

interface PlayerMount {
  type: string
  expires: number
  benefit: string
  cooldown_bonus: number
}

const SLIDES = [
  { name: 'Donkey',  img: donkeyImg },
  { name: 'Horse',   img: horseImg },
  { name: 'Unicorn', img: unicornImg },
]

export default function StablePage() {
  const [loading, setLoading]     = useState(true)
  const [error, setError]         = useState<string | null>(null)
  const [mounts, setMounts]       = useState<MountOption[]>([])
  const [current, setCurrent]     = useState<PlayerMount | null>(null)
  const [buying, setBuying]       = useState<string | null>(null)
  const [slideIdx, setSlideIdx]   = useState(0)

  useEffect(() => {
    api.get<{ mounts: MountOption[]; current: PlayerMount | null }>('/stable')
      .then(res => {
        setMounts(res.data.mounts)
        setCurrent(res.data.current)
      })
      .catch(err => setError(err.response?.data?.error || err.message))
      .finally(() => setLoading(false))
  }, [])

  const handleBuy = (name: string) => {
    setBuying(name)
    api.post<{ mount: PlayerMount }>('/stable/buy', { mountName: name })
      .then(res => setCurrent(res.data.mount))
      .catch(err => alert(err.response?.data?.error || err.message))
      .finally(() => setBuying(null))
  }

  const prevSlide = () =>
    setSlideIdx(i => (i === 0 ? SLIDES.length - 1 : i - 1))
  const nextSlide = () =>
    setSlideIdx(i => (i === SLIDES.length - 1 ? 0 : i + 1))

  const now = Date.now()
  const slide  = SLIDES[slideIdx]
  const option = mounts.find(m => m.name === slide.name)

  return (
    <div className="stable-page">
      <div className="stable-container">

        {loading ? (
          <p className="loading">Loading mounts…</p>
        ) : error ? (
          <p className="error">{error}</p>
        ) : option && (
          <div className="slideshow-container">
            <button className="slide-btn prev" onClick={prevSlide}>‹</button>
            <img src={slide.img} alt={slide.name} className="slide-img"/>
            <button className="slide-btn next" onClick={nextSlide}>›</button>
            <div className="slide-caption">{slide.name}</div>

            <div className="slide-details">
              <p className="benefit">{option.benefit}</p>
              <p className="cost">
                Cost: {option.price_silver} silver
                {option.price_gold > 0 && ` / ${option.price_gold} gold`}
              </p>
              <p className="duration">Duration: 24 hours</p>
            </div>

            {current?.type === option.name && current.expires > now ? (
              <span className="owned-badge">Equipped</span>
            ) : (
              <button
                className="mount-btn"
                style={{ backgroundImage: `url(${buttonImg})` }}
                onClick={() => handleBuy(option.name)}
                disabled={buying !== null}
              >
                {buying === option.name ? 'Buying…' : `Buy ${option.name}`}
              </button>
            )}

            {current && current.expires > now && (
              <div className="current-info">
                You own: <strong>{current.type}</strong> — expires in{' '}
                <strong>{Math.ceil((current.expires - now)/60000)} min</strong>
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  )
}
